import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  searchBarOuterWrapper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  searchInputCell: {
    maxWidth: 420,
  },
  tableScrollWrapper: {
    overflowX: 'auto',
  },
  statusCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  statusIcon: {
    fontSize: '1.1rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inProgressIcon: {
    color: theme.palette.warning.main,
  },
  inactiveIcon: {
    color: theme.palette.text.secondary,
  },
  overdueIcon: {
    color: theme.palette.error.main,
  },
  stackedCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  mutedText: {
    color: theme.palette.text.secondary,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  requestTypes: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  requestTypeChip: {
    maxWidth: 160,
  },
  actionsCell: {
    display: 'flex',
    justifyContent: 'center',
  },
  emptyState: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  dialogIntro: {
    marginBottom: theme.spacing(3),
  },
  formSection: {
    marginTop: theme.spacing(3),
  },
  formGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formFullWidth: {
    gridColumn: '1 / -1',
  },
  groupedFields: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr',
  },
  checkboxGroup: {
    display: 'grid',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  checkboxGroupLabel: {
    marginBottom: theme.spacing(1),
  },
  checkboxError: {
    marginTop: theme.spacing(1),
  },
  resizableTextarea: {
    resize: 'vertical',
    minHeight: theme.spacing(14),
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
  },
  detailWrapper: {
    display: 'grid',
    gap: theme.spacing(3),
  },
  detailActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
  detailActionButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  detailActionButton: {
    whiteSpace: 'nowrap',
  },
  detailBanner: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    borderLeft: `4px solid ${theme.palette.info.main}`,
    backgroundColor: theme.palette.grey[100],
  },
  detailBannerWarning: {
    borderLeftColor: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
  },
  detailBannerInfo: {
    borderLeftColor: theme.palette.info.main,
    backgroundColor: theme.palette.grey[100],
  },
  detailGrid: {
    display: 'grid',
    alignItems: 'start',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  detailCard: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  detailField: {
    display: 'grid',
    gap: theme.spacing(0.5),
  },
  detailLabel: {
    color: theme.palette.text.secondary,
  },
  detailValue: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}));

export default useStyles;
